<template>
  <input
    v-model.trim="modelValue"
    placeholder="MPS123"
    type="text"
  >
</template>

<script>
/**
 * @module RefCodeInput
 */
export default {
  name: 'RefCodeInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    modelValue: {
      get: ({ value }) => value,
      set (value) {
        this.$emit('input', value.toUpperCase())
      }
    }
  }
}
</script>
